import React from 'react';
import clsx from 'clsx';
import ToastWrapper from './ToastWrapper';

const PositiveToast = ({
  children,
  className,
  icon = 'check circle',
}) => (
  <ToastWrapper
    className={clsx('aridhia-positive-toast toast-message', className)}
    color="green"
    icon={icon}
  >
    {children}
  </ToastWrapper>
);

export default PositiveToast;
